import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { ReceiptChartProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useReceiptService } from "serviceHooks";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
import { ChartPeriodClickArgs } from "models/propTypes/chartProps";
//#endregion

const ReceiptMonthlyPurchasesDistributionChart: React.FC<ReceiptChartProps> = (props) => {
  const receiptService = useReceiptService();
  const labelFormatter = (label?: string) => label?.substring(0, 3) ?? "";

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Bar}
      chartAPIKey={GraphConstants.ChartKeys.ReceiptPurchasesPerMonth}
      filterToAPIHandler={receiptService.reportToAPIFilter}
      usePageFilter={false}
      labelFormatter={labelFormatter}
      accumulatedChartAPIKey={GraphConstants.ChartKeys.ReceiptPurchasesPerMonthAccumulated}
      useClickableChart
      onDataPointClickedSetFilter={(arg) => {
        const args = arg as ChartPeriodClickArgs | undefined;
        return args?.start && args?.end ? { created: { start: args.start, end: args.end } } : {};
      }}
      onBackgroundClickedSetFilter={{ created: undefined }}
    />
  );
};

export default ReceiptMonthlyPurchasesDistributionChart;
